module.exports = __webpack_public_path__ + "img/involvement_2_tablet.e1ed465.jpg";